import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { QualificationRequirement } from './types/QualificationRequirement';
import { RequiredDocuments } from './types/RequiredDocuments';

export default (makeCall: MakeCall) =>
  (listingUuid: string, data: Array<RequiredDocuments>) =>
    makeCall<QualificationRequirement>(
      'PUT',
      `/api/v2/qualification/requirements/${listingUuid}`,
      {
        data: {
          documents: data,
        },
      },
    );
